import React, { useState, useEffect } from 'react';
import MobileFilterCollapse, { searchSummary } from '../common/form/MobileFilterCollapse';
import { Box, Button, MenuItem, Stack, TextField } from '@mui/material';
import 'dayjs/locale/ko';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; 
import dayjs from 'dayjs';
import SalesDeptUserFilter from '../common/form/SalesDeptUserFilter';
import MobileSearchAdornment from '../common/search/MobileSearchAdornment';
import {
  firstDayofYear,
  getFirstDayOfYear,
  getLastDayOfYear,
  lastDayofYear,
  subYearStrDt,
} from '../../utils/calcDatetime';

export const ChanceListBox = ({ isAdd = false, handleFirstForecast, formik }) => {
  // export const ChanceListBox = ({ isAdd = false, handleAddForecast, handleFirstForecast, formik }) => {
  const [searchStrtDt, setSearchStrtDt] = useState(null);
  const [searchEndDt, setSearchEndDt] = useState(null);
  useEffect(() => {
    if (formik.values.searchStrtDt) {
      setSearchStrtDt(dayjs(formik.values.searchStrtDt));
    }
    if (formik.values.searchEndDt) {
      setSearchEndDt(dayjs(formik.values.searchEndDt));
    }
  }, [formik.values.searchStrtDt, formik.values.searchEndDt]);

  const handleChangeThisYear = () => {
    formik.setFieldValue('searchStrtDt', firstDayofYear);
    formik.setFieldValue('searchEndDt', lastDayofYear);
  };

  const handleChangeLastYear = () => {
    const paramDate = subYearStrDt(1);
    const strDt = getFirstDayOfYear(paramDate);
    const endDt = getLastDayOfYear(paramDate);

    formik.setFieldValue('searchStrtDt', strDt);
    formik.setFieldValue('searchEndDt', endDt);
  };

  return (
    <MobileFilterCollapse summary={searchSummary(formik.values)}>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        my: { xs: 0.75, md: 1 },
        minWidth: 0,
        width: '100%',
      }}
    >
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
          justifyContent: 'flex-end',
          alignItems: { xs: 'stretch', lg: 'center' },
          gap: { xs: 1, lg: 1.5 },
        }}
        onSubmit={formik.handleSubmit}
      >
        <Box
          sx={{
            flexGrow: 1,
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, minmax(0, 1fr))',
              // 검색 필드가 7개(부서·사원·시작일·종료일·연도버튼·키워드·검색어)다.
              // 날짜는 형식이 고정(YYYY-MM-DD)이라 폭을 고정하고, 남는 폭은 이름·검색어가 쓰게 한다.
              lg: 'repeat(4, minmax(140px, 1fr))',
              xl: 'minmax(120px, 1fr) minmax(120px, 1fr) 165px 165px auto minmax(110px, 0.8fr) minmax(130px, 1.2fr)',
            },
            alignItems: 'end',
            gap: { xs: 1.25, md: 1.5 },
            minWidth: 0,
            '& .MuiFormControl-root': {
              width: '100%',
            },
          }}
        >
          <SalesDeptUserFilter formik={formik} />

          <Box sx={{ minWidth: 0 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
              <DatePicker
                label="매출 시작일"
                format="YYYY-MM-DD"
                mask={'____-__-__'}
                id="searchStrtDt"
                 name="searchStrtDt"
                value={dayjs(searchStrtDt)}
                onChange={(newValue) => {
                  setSearchStrtDt(dayjs(newValue));
                  formik.setFieldValue('searchStrtDt', dayjs(newValue));
                }}
                slotProps={{
                  textField: {
                    variant: 'standard',
                    fullWidth: true,
                    error: formik.touched.searchStrtDt && Boolean(formik.errors.searchStrtDt),
                    helperText: formik.touched.searchStrtDt && formik.errors.searchStrtDt,
                  },
                }}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
              <DatePicker
                label="매출 종료일"
                format="YYYY-MM-DD"
                mask={'____-__-__'}
                id="searchEndDt"
                name="searchEndDt"
                value={dayjs(searchEndDt)}
                onChange={(newValue) => {
                  setSearchEndDt(dayjs(newValue));
                  formik.setFieldValue('searchEndDt', dayjs(newValue));
                }}
                slotProps={{
                  textField: {
                    variant: 'standard',
                    fullWidth: true,
                    error: formik.touched.searchEndDt && Boolean(formik.errors.searchEndDt),
                    helperText: formik.touched.searchEndDt && formik.errors.searchEndDt,
                  },
                }}
              />
            </LocalizationProvider>
          </Box>
          <Stack
            direction="row"
            spacing={1}
            sx={{
              alignItems: 'center',
              '& .MuiButton-root': {
                flex: { xs: 1, sm: 'initial' },
                minWidth: { xs: 0, sm: 64 },
              },
            }}
          >
            <Button
              variant="outlined"
              color="info"
              onClick={handleChangeThisYear}
            >
              금년
            </Button>
            <Button
              variant="outlined"
              color="info"
              onClick={handleChangeLastYear}
            >
              작년
            </Button>
          </Stack>
          <TextField
            variant="standard"
            required={false}
            select
            id="searchKeyword"
            name="searchKeyword"
            label="검색키워드"
            value={formik.values.searchKeyword}
            onChange={formik.handleChange}
            error={formik.touched.searchKeyword && Boolean(formik.errors.searchKeyword)}
            helperText={formik.touched.searchKeyword && formik.errors.searchKeyword}
          >
            <MenuItem value="cstNm">사업명</MenuItem>
            <MenuItem value="prjNo">프로젝트 번호</MenuItem>
            <MenuItem value="vendorCmpNm">매출처명</MenuItem>
            <MenuItem value="crtDptNm">부서</MenuItem>
            <MenuItem value="crtNm">영업담당자</MenuItem>
            <MenuItem value="cstStatus">상태</MenuItem>
          </TextField>
          <TextField
            variant="standard"
            required={false}
            id="searchWords"
            name="searchWords"
            label="검색어"
            value={formik.values.searchWords}
            onChange={formik.handleChange}
            error={formik.touched.searchWords && Boolean(formik.errors.searchWords)}
            helperText={formik.touched.searchWords && formik.errors.searchWords}
            InputProps={{
              endAdornment: <MobileSearchAdornment disabled={formik.isSubmitting} />,
            }}
          />
        </Box>
        <Box sx={{ width: { xs: '100%', lg: 'auto' } }}>
          <Button
            type="submit"
            color="info"
            variant="contained"
            disabled={formik.isSubmitting}
            fullWidth
            sx={{ minHeight: 40, px: 3, whiteSpace: 'nowrap', minWidth: 88 }}
          >
            검색
          </Button>
        </Box>
      </Box>
    </Box>
    </MobileFilterCollapse>
  );
};
